export const themes = {
  default: {
    primary: '#0F4D2E',           // dark green — headers, buttons, links
    primaryLight: '#006747',       // medium green — selects, nav hover
    primaryHover: '#0a3d24',       // button hover (darker primary)
    primaryDisabled: '#a5c8b0',    // button disabled background
    panelBg: '#C7DEBD',            // light green — panel backgrounds
    panelBgAlt: '#BAD6AD',         // slightly darker green — banner, inactive buttons
    panelBgFade: 'rgba(199,222,189,0.95)', // panel bg as rgba for gradient overlays
    navHover: '#90BE7C',           // nav hover background
    navBg: '#63B537',              // top navigation bar background
    navBgMobile: '#63B537',        // mobile dropdown background (top)
    navBgMobileBottom: '#8fce6a',  // mobile dropdown background (bottom gradient)
    navText: '#0F4D2E',            // nav link color
    logo: 'default',              // which logo to show in Banner
    scorecardHoles: '#738f38',     // scorecard hole header row
    scorecardHcp: '#948357',       // scorecard handicap row
    scorecardPar: '#ddd4b7',       // scorecard par row
    bodyBg: '#C7DEBD',
    bodyText: '#060',
    // Semantic surface colors — used by components directly, no themeName checks needed
    rowBg: '#ffffff',              // table/scorecard primary row background
    rowBgAlt: '#f5f5f5',          // table/scorecard alternating row background
    drawerBg: null,               // swipeable drawer background (null = MUI default)
    muiOverride: false,           // true = apply dark MUI palette/component overrides in App.js
  },
  dark: {
    primary: '#4CAF8A',           // muted teal-green — headers, buttons, links
    primaryLight: '#3d9973',      // slightly darker teal
    primaryHover: '#3a8c68',      // button hover
    primaryDisabled: '#2a4a3d',   // button disabled (dark, desaturated)
    panelBg: '#1e2a24',           // very dark green-tinted background
    panelBgAlt: '#253022',        // slightly lighter dark — banner, inactive
    panelBgFade: 'rgba(30,42,36,0.95)', // for gradient overlays
    navHover: '#2d3d34',          // nav hover background
    navBg: '#121a16',             // near-black navbar
    navBgMobile: '#121a16',
    navBgMobileBottom: '#1e2a24',
    navText: '#a8d5bc',           // soft mint — nav links
    logo: 'default',
    scorecardHoles: '#2e4a38',    // dark header row
    scorecardHcp: '#1e3228',      // darker row
    scorecardPar: '#253022',      // dark alt row
    bodyBg: '#141a16',            // page background
    bodyText: '#d4eadd',          // light mint text
    rowBg: '#1e2a24',             // table/scorecard primary row background
    rowBgAlt: '#253022',          // table/scorecard alternating row background
    drawerBg: '#1e2a24',          // swipeable drawer background
    muiOverride: true,            // apply dark MUI palette/component overrides
  },
  starwars: {
    primary: '#FFE81F',           // Star Wars yellow — headers, buttons, links
    primaryLight: '#ceba00',      // darker yellow — selects, nav hover
    primaryHover: '#b3a200',      // button hover
    primaryDisabled: '#4a4400',   // button disabled (dark, desaturated yellow)
    panelBg: '#0d0d0d',           // near-black space background
    panelBgAlt: '#1a1a1a',        // slightly lighter dark — banner, inactive
    panelBgFade: 'rgba(13,13,13,0.95)', // for gradient overlays
    navHover: '#2a2a00',          // nav hover background (dark yellow tint)
    navBg: '#000000',             // pure black navbar
    navBgMobile: '#000000',
    navBgMobileBottom: '#0d0d0d',
    navText: '#FFE81F',           // Star Wars yellow — nav links
    logo: 'default',
    scorecardHoles: '#3a3000',    // dark yellow header row
    scorecardHcp: '#1a1500',      // darker row
    scorecardPar: '#1a1a1a',      // dark alt row
    bodyBg: '#000000',            // pure black page background
    bodyText: '#FFE81F',          // Star Wars yellow text
    rowBg: '#0d0d0d',             // table/scorecard primary row background
    rowBgAlt: '#1a1a1a',          // table/scorecard alternating row background
    drawerBg: '#0d0d0d',          // swipeable drawer background
    muiOverride: true,            // apply dark MUI palette/component overrides
  },
  strangerthings: {
    primary: '#cc0000',           // blood red — headers, buttons, links
    primaryLight: '#a30000',      // darker red — selects, nav hover
    primaryHover: '#8b0000',      // button hover
    primaryDisabled: '#4a1a1a',   // button disabled (dark, desaturated red)
    panelBg: '#1a0a0a',           // near-black red-tinted background
    panelBgAlt: '#240d0d',        // slightly lighter dark red — banner, inactive
    panelBgFade: 'rgba(26,10,10,0.95)', // for gradient overlays
    navHover: '#3d1515',          // nav hover background
    navBg: '#0d0505',             // near-black navbar
    navBgMobile: '#0d0505',
    navBgMobileBottom: '#1a0a0a',
    navText: '#ff6b6b',           // soft red — nav links
    logo: 'default',
    scorecardHoles: '#7a0000',    // dark blood red header row
    scorecardHcp: '#4a0000',      // darker row
    scorecardPar: '#240d0d',      // dark alt row
    bodyBg: '#0d0505',            // page background — almost black
    bodyText: '#ff9999',          // soft red-pink text
    rowBg: '#1a0a0a',             // table/scorecard primary row background
    rowBgAlt: '#240d0d',          // table/scorecard alternating row background
    drawerBg: '#1a0a0a',          // swipeable drawer background
    muiOverride: true,            // apply dark MUI palette/component overrides
  },
  canada: {
    primary: '#D52B1E',            // Canadian red — headers, buttons, links
    primaryLight: '#b01f14',       // darker red — selects, nav hover
    primaryHover: '#a02015',       // button hover (darker primary)
    primaryDisabled: '#e8a09b',    // button disabled background (muted red)
    panelBg: '#FFECEC',            // very light red/pink — panel backgrounds
    panelBgAlt: '#FFCFCF',         // slightly darker pink — banner, inactive buttons
    panelBgFade: 'rgba(255,236,236,0.95)', // panel bg as rgba for gradient overlays
    navHover: '#FFB3B3',           // nav hover background
    navBg: '#D52B1E',              // top navigation bar background
    navBgMobile: '#D52B1E',        // mobile dropdown background (top)
    navBgMobileBottom: '#b01f14',  // mobile dropdown background (bottom gradient)
    navText: '#ffffff',            // nav link color (white on red)
    logo: 'canada',               // which logo to show in Banner
    scorecardHoles: '#D52B1E',     // scorecard hole header row
    scorecardHcp: '#8B0000',       // scorecard handicap row (dark red)
    scorecardPar: '#FFE4E1',       // scorecard par row (misty rose)
    bodyBg: '#FFECEC',
    bodyText: '#1a0000',
    rowBg: '#ffffff',              // table/scorecard primary row background
    rowBgAlt: '#f5f5f5',          // table/scorecard alternating row background
    drawerBg: null,               // swipeable drawer background (null = MUI default)
    muiOverride: false,           // no dark MUI overrides needed
  },
  masters: {
    primary: '#1B4D1B',           // Augusta dark green — headers, buttons, links
    primaryLight: '#2d6b2d',      // medium green — selects, nav hover
    primaryHover: '#143d14',      // button hover (darker primary)
    primaryDisabled: '#8aab8a',   // button disabled background
    panelBg: '#F5F0E8',           // parchment cream — panel backgrounds
    panelBgAlt: '#EAE3D2',        // slightly darker cream — banner, inactive buttons
    panelBgFade: 'rgba(245,240,232,0.95)', // panel bg as rgba for gradient overlays
    navHover: '#2d6b2d',          // nav hover background
    navBg: '#1B4D1B',             // Augusta dark green navbar
    navBgMobile: '#1B4D1B',       // mobile dropdown background (top)
    navBgMobileBottom: '#143d14', // mobile dropdown background (bottom gradient)
    navText: '#FFD700',           // Masters gold — nav links
    logo: 'default',
    scorecardHoles: '#1B4D1B',    // dark green header row
    scorecardHcp: '#476A30',      // mid green row
    scorecardPar: '#EAE3D2',      // cream par row
    bodyBg: '#EEE8D8',            // warm off-white page background
    bodyText: '#1B3A1B',          // dark green text
    rowBg: '#ffffff',             // table primary row background
    rowBgAlt: '#F5F0E8',          // cream alternating row
    drawerBg: null,
    muiOverride: false,
  },
};

